<template>
  <div id="app">
    {{ message }}
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: 'Hello World'
    }
  }
}
</script>